export default __webpack_public_path__ + "static/media/INEX_old.627d087a.png";